<template>
    <div id="app">
        <transition>
            <keep-alive>
                <!--页面设置缓存设置route meta keepAlive-->
                <router-view  v-wechat-title='$route.meta.title' v-if="$route.meta.keepAlive"/>
            </keep-alive>
        </transition>
        <!--默认页面不设置缓存-->
        <router-view  v-wechat-title='$route.meta.title' v-if="!$route.meta.keepAlive"/>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    export default {
        name: 'App',
        data(){
            return{
                isPlay:false,
                isRotate:'',
                angle:0,
            }
        },
        computed: {
            ...mapState({
                src: state => state.musicSrc,
                time: state=> state.musicTime,
                client: state => state.client,
            }),
        },
        created: function() {
            /**
             * 功能：处理扫码功能
             * 注意：支付成功之后清理sessionStorage.user_id
             */
            // (function(){
            //     window.alert = function(name){
            //         var iframe = document.createElement("IFRAME");
            //         iframe.style.display="none";
            //         console.log(iframe)
            //         iframe.setAttribute("src", 'data:text/plain');
            //         document.documentElement.appendChild(iframe);
            //         window.frames[0].window.alert(name);
            //         iframe.parentNode.removeChild(iframe);
            //     }
            // })();
            var self = this
            let search = location.search;
            let searchObj = {};
            if(search) {
                search = decodeURIComponent(location.search);
                if(search[0] === '?') search = search.substring(1);
                if(search[search.length -1] === '=') search = search.substring(0, search.length -1);
                let searchArr = search.split('&');
                searchArr.map(item => {
                    const arr = item.split('=');
                    searchObj[arr[0]] = arr[1];
                })
            }
            const {user_id, from,avatar, token, auth_user_id} = searchObj;

            if(token) {
                window.localStorage.setItem("avatar",avatar);
                window.localStorage.setItem('token', token);
                var p = window.location.origin + window.location.pathname
                var url = window.location.search
                var strs,local =  window.location.pathname == '/' ?'?check=true&': '?check=true&'
                var thisParam = new Object();
                if (url.indexOf("?") != -1) {
                    var str = url.substr(1);
                    strs = str.split("&");
                    for(var i = 0; i < strs.length; i ++) {
                        thisParam[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
                    }
                    setTimeout(function () {
                        if(thisParam.token){
                            for(i in thisParam){
                                if(i != 'token' && i!='auth_user_id'){
                                    local =  local + i + '=' + thisParam[i] +'&'
                                }
                                console.log(p + local)
                            }
                            setTimeout(function () {
                                window.location.href = p + local
                            },200)
                        }
                    },10)
                }
            }
        },
        methods:{
        }
    }
</script>

<style>
    @import "~flex.css";
    @import "~mint-ui/lib/style.css";
    @import "~vant/lib/index.css";
    @import "~swiper/dist/css/swiper.css";
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        font-size: 0.36rem;
        width: 100%;
        max-width: 7.5rem;
        margin: 0 auto;
        height: 100vh;
        overflow: hidden;

    }
    .head{
        display: flex;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: .8rem;
    }
    .head>img{
        height: .46rem;
        margin-left: .2rem;
        transform: rotate(180deg);
    }
    .head p{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        line-height: .8rem;
        font-weight: bold;
        text-align: center;
        font-size: .36rem;
    }

    .picker-custom .picker-toolbar {
        height: 56px;
        text-align: center;
    }
    .picker-custom .mint-datetime-action {
        width: 58px;
        height: 30px;
        line-height: 30px;
        margin-top: 13px;
        background: #000000;
        border-radius:4px;
        color: #ffffff;
    }
    .picker-custom .mint-datetime-cancel {
        margin-left: 16px;
    }

    .picker-custom .mint-datetime-confirm {
        margin-right: 16px;
    }
    /* 改变mint-ui loading记载的样式 */
    .mint-indicator-wrapper {
        padding: 15px 30px !important;
    }
    .mint-spinner-fading-circle {
        width: 40px !important;
        height: 40px !important;
    }
    .one-fix-btn{
        width: 100%;
        height: 1.2rem;
        position: fixed;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #EE8002;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue